const VISITOR_TOKEN_PREFIX = "customer-chat-visitor-v1:";

function storageKey(scope: string): string {
  return `${VISITOR_TOKEN_PREFIX}${scope.trim().toLowerCase()}`;
}

export function readStoredVisitorToken(orgSlug: string): string | null {
  return readStoredVisitorTokenForScope(orgSlug);
}

export function persistVisitorToken(orgSlug: string, token: string): void {
  persistVisitorTokenForScope(orgSlug, token);
}

export function readStoredEmbedVisitorToken(siteKey: string): string | null {
  return readStoredVisitorTokenForScope(`embed:${siteKey}`);
}

export function persistEmbedVisitorToken(siteKey: string, token: string): void {
  persistVisitorTokenForScope(`embed:${siteKey}`, token);
}

function readStoredVisitorTokenForScope(scope: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(storageKey(scope));
    const trimmed = raw?.trim() ?? "";
    return trimmed.length > 0 ? trimmed : null;
  } catch {
    return null;
  }
}

function persistVisitorTokenForScope(scope: string, token: string): void {
  try {
    window.localStorage.setItem(storageKey(scope), token);
  } catch {
    /* private mode / quota — non-fatal */
  }
}
